<div class="folder-icons">
    <div *ngFor="let project of projects" class="folder-icon" (click)="openProject(project.component)">
        <span><img src='/assets/icons/Folder.PNG' alt="{{ project.name }}"></span><br>
        <span>{{ project.name }}</span>
    </div>
</div>

<!-- <app-window *ngFor="let project of openProjectsData" [title]="project.name" [component]="project.component" 
    (close)="closeProject(project.component)" (mousedown)="onClick(project.component)"></app-window> -->